import GrmMediapipeDefault from "./grm-mediapipie-default";

export default class GrmMediapipeLegacy extends GrmMediapipeDefault {
    #requestAnimationFrameId = null;
    #video;
    
    constructor(options={}) {
        super(options);
    }
    
    checkTrackProcessor(){
        return !!this.#video;
    }
    
    async syncStream(){
        const video = await this.getVideo();
        if(video.srcObject === this.srcStream){
            return;
        }

        video.srcObject = this.srcStream;
        video.play().catch(e => {
            console.warn('play error (syncStream)', video.paused, video.currentTime, e);
        });
    }
    
    getCanvas(){
        if(this.canvas){
            return this.canvas;
        }

        const canvas = this.canvas = document.createElement('canvas');
        Object.assign(canvas.style, {
            position: 'absolute',
            right: '0px', bottom: '0px',
            'pointer-events': 'none',
            'opacity': '0',
            'background-color':'black',
        });
        document.body.append(canvas);

        this.canvasCtx = canvas.getContext('2d');

        this.syncStreamAndCanvas();

        return this.canvas;
    }
    
    async getVideo(){
        if(this.#video){
            return this.#video;
        }

        if(!this.srcStream){
            throw 'stream is null';
        }

        const video = this.#video = document.createElement('video');
        Object.assign(video.style, {
            position: 'absolute',
            right: '0px', bottom: '0px',
            'pointer-events': 'none',
            'opacity': '0'
        });
        video.muted = true;
        video.autoplay = true;
        video.setAttribute('playsinline', '');

        document.body.append(video);

        ['loadedmetadata', 'resize'].forEach(type => {
            video.addEventListener(type, e => {
                this.syncStreamAndCanvas();
            })
        })

        await this.syncStream();

        return video;
    }
    
    disabled(){
        if (this.#requestAnimationFrameId) {
            cancelAnimationFrame(this.#requestAnimationFrameId);
            this.#requestAnimationFrameId = null;
        }
    }

    async getDstStream(){
        const canvas = this.getCanvas();
        if(!canvas){
            throw 'canvas is null';
        }

        if(!this.dstStream || !this.dstStream.active){
            const dstStream = this.dstStream = canvas.captureStream();

            (() => {
                const customStopEventType = '_grm_mmp_stop';
                const event = new Event(customStopEventType);
                event._grm_event = {};
                
                const srcStream = this.srcStream;
                const srcVideoTrack = srcStream.getVideoTracks()[0];
                const dstVideoTrack = dstStream.getVideoTracks()[0];
                srcVideoTrack.addEventListener(customStopEventType, e => {
                    dstVideoTrack.stop();
                });      
                
                const ori_stop = dstVideoTrack.stop;
                dstVideoTrack.stop = () => {
                    this.dstStream = null
                    ori_stop.apply(dstVideoTrack, arguments);
                    srcStream.getVideoTracks()[0]?.dispatchEvent(event);
                    return true;
                }
            })();

            if(this.srcStream){
                this.srcStream.getTracks().forEach(t => {
                    if(t.kind !== 'video'){
                        stream.addTrack(t);
                    }
                })
            }
        }
        return this.dstStream;
    }
    
    async setBackground({onResult}){
        const selfieSegmentation = await this.getSelfieSegmentation({create: true})
        selfieSegmentation.onResults(onResult);

        const video = await this.getVideo();

        let ct = 0, ct_time = 0;
        let fcnt = 0;
        let pid = 'gmp-'+Date.now();
        let st = Date.now();
        const send = () => {
            window.cancelAnimationFrame(this.requestAnimationFrameId);
            this.requestAnimationFrameId = window.requestAnimationFrame(async () => {
                if(video.paused || video.currentTime === ct){
                    if(video.srcObject && video.srcObject.getVideoTracks().length === 0){
                        console.log('send');
                        return;
                    }
                    if(++fcnt > 100){
                        console.log('send stoped : pid[%s] (%dms)', pid, Date.now()-st);
                        // return;
                    }
                    send();
                    return;
                }
                ct = video.currentTime;
                fcnt = 0;

                if(video.videoWidth === 0 || video.videoHeight === 0){
                    send();
                    return;
                }
                video.width = video.videoWidth;
                video.height = video.videoHeight;
                await selfieSegmentation.send({image: video});
                send();
            });
        };
        send();

        const dstStream = await this.getDstStream();
        return dstStream;
    }
    async setNoneBackground(){
        const video = await this.getVideo();
        video.pause();
        window.cancelAnimationFrame(this.requestAnimationFrameId);
    }
} 